require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./lesson-three-code-of-conduct.json") })
        }
      }, "path---lesson-three-code-of-conduct");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---lesson-three-code-of-conduct!./.cache/json/lesson-three-code-of-conduct.json
// module id = 373
// module chunks = 231608221292675